<template>
  <b-modal
    id="transformations-modal"
    ref="transformationsModal"
    :title="`${templateFieldName} Transformation`"
    size="lg"
    scrollable
    @close="hideModal"
  >
    <div style="min-height: 400px">
      <b-row
        v-for="(transformation, index) in transformations"
        :key="index"
        class="p-1"
        :class="{'border-bottom': index !== transformations.length - 1}"
      >
        <b-col cols="11">
          <TransformationForm
            ref="transFomrationRefs"
            :transformation="Array.isArray(transformation) ? transformation[0] : transformation"
            :scripts="scripts"
            :xlsx-headers="xlsxHeaders"
            :table-headers="tableHeaders"
            :template-fields="templateFields"
            :context="context"
            :table-column-index="templateFieldIndex"
          />
        </b-col>

        <b-col
          cols="1"
          class="d-flex justify-content-center align-items-center"
        >
          <button
            v-if="index !== transformations.length - 1"
            class="btn btn-danger"
            @click="removeTransformation(index)"
          >
            <i class="bi bi-trash" />
          </button>
        </b-col>
      </b-row>
    </div>

    <template #modal-footer>
      <div>
        <b-button
          variant="secondary"
          @click="hideModal"
        >
          Cancel
        </b-button>

        <b-button
          variant="primary"
          @click="addTransformation"
        >
          Add another transformation
        </b-button>

        <b-button
          variant="primary"
          @click="saveTransformations"
        >
          Save transformation settings
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import TransformationForm from "@frontend/components/modules/edit-page/import/transformations/TransformationForm.vue";
import { transformationsEventBroker, TRANSFORMATIONS_EVENTS } from "@frontend/components/modules/edit-page/import/transformations/event-broker";

export default {
  name: 'TransformationsModal',
  components: {
    TransformationForm,
  },
  data() {
    return {
      transformations: [],
      containerQuery: null,
      templateId: null,
      templateFieldName: null,
      templateFieldIndex: null,
      scripts: [],
      xlsxHeaders: [],
      tableHeaders: [],
      templateFields: [],
      context: 'field', // 'field' for field values, 'table' for table columns
    }
  },
  mounted() {
    window.transformationsModal = this;
  },
  methods: {
    showModal(eventData) {
      this.transformations = eventData.transformationSettings || [];
      this.containerQuery = eventData.containerQuery;
      this.templateId = eventData.templateId;
      this.templateFieldName = eventData.templateFieldName;
      this.templateFieldIndex = eventData.templateFieldIndex;
      this.xlsxHeaders = eventData.xlsxHeaders || [];
      this.tableHeaders = this.getHeadersForCurrentTableField();
      this.context = eventData.context || 'field'; // 'field' or 'table'
      this.getTemplateFields();

      if (this.transformations.length === 0) {
        this.addTransformation();
      }

      this.$refs.transformationsModal.show();
    },
    getTemplateFields() {
      if (!this.templateId) return;
      // Select the container div by ID
      const container = document.getElementById(`feed_template_container_${this.templateId}`);

      // Get all elements with the class "field-mapping" inside the container.
      // Shapes are excluded: they never hold a value, so as a related field they always read as empty.
      const fields = container.querySelectorAll('.field-mapping:not(.field-mapping-shape)');

      // Extract the name attributes
      this.templateFields = Array.from(fields).map(field => field.getAttribute('name')).filter(name => name !== null);

    },
    getHeadersForCurrentTableField() {
      if (!this.containerQuery || this.templateFieldIndex === null || this.templateFieldIndex === undefined) {
        return [];
      }

      const index = String(this.templateFieldIndex);
      const selector = `${this.containerQuery} .field-mapping-transformation[data-template-field-index="${index}"]`;

      const transformationInput = document.querySelector(selector);
      if (!transformationInput) {
        return [];
      }

      const wrapper = transformationInput.closest('.col-sm-4') || transformationInput.parentElement;
      const select = wrapper ? wrapper.querySelector('select.field-mapping') : null;

      if (!select) {
        return [];
      }

      const raw = select.getAttribute('data-table-headers');
      if (!raw) {
        return [];
      }

      try {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed)
          ? parsed.map((h) => (h === null || h === undefined ? '' : String(h)).trim()).filter((h) => h !== '')
          : [];
      } catch (e) {
        return [];
      }
    },
    hideModal() {
      this.$refs.transformationsModal.hide();
      transformationsEventBroker.fire(TRANSFORMATIONS_EVENTS.HIDE_TRANSFORMATIONS_MODAL);
    },
    addTransformation() {
      this.transformations.push({transformation: null, variables: {}});
    },
    removeTransformation(index) {
      this.transformations.splice(index, 1);
    },
    saveTransformations() {
      const transformations = this.collectTransformations();

      transformationsEventBroker.fire(TRANSFORMATIONS_EVENTS.UPDATE_TRANSFORMATIONS, {
        transformations: transformations,
        containerQuery: this.containerQuery,
        templateId: this.templateId,
        templateFieldName: this.templateFieldName,
        templateFieldIndex: this.templateFieldIndex,
        context: this.context
      });

      this.hideModal();
    },
    collectTransformations() {
      return this.$refs.transFomrationRefs.map(transformationComponent => transformationComponent.getTransformationData())
        .filter(transformation => transformation.transformation);
    },
    setScripts(scripts) {
      this.scripts = scripts;
    },
  },
}
</script>
